/* eslint-disable */

<template>
  <div class="empmyrequests">
    <div class="container-fluid">
      <AddRequest show="true" />
    </div>
  </div>
</template>

<script>
import AddRequest from "@/components/AddRequest.vue";

export default {
  name: "EmpMyRequests",
  components: { AddRequest },
  props: {},
  data() {
    return {
    }
  },
};
</script>

<style scoped lang="scss"></style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
